import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Report from "@/pages/Report";
import { trackPageview } from "@/lib/api";

const TOAST_OPTIONS = {
  style: {
    background: "#0a0a0a",
    border: "1px solid #262626",
    color: "#F5F5F5",
    borderRadius: 0,
    fontFamily: "Manrope, sans-serif",
  },
};

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/report" element={<Report />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={TOAST_OPTIONS}
      />
    </div>
  );
}

export default App;
